// extracted by mini-css-extract-plugin
module.exports = {"client-requirements":"ClientRequirementsView_client-requirements__1v61H","conflicted":"ClientRequirementsView_conflicted__5hmJU"};